// Where each help control in the app sends people. Tools name a topic
// ('qpadm.build'); this maps it to a video and, optionally, the chapter to
// start at — by title, so the timestamp comes from the registry and follows
// the narration when a cut is re-rendered. Video ids are the registry's stable
// ids (videos.json, written by docs/capture/publish.mjs), never slugs, so a
// URL can change without touching a tool.
//
// Add a topic here and reference it from a HelpVideoButton; nothing else.
export default {
    upload:          { videoId: 'uploadDna' },
    admix:           { videoId: 'admixCalculators' },
    nmonte:          { videoId: 'nmonteG25' },
    g25coords:       { videoId: 'g25Coordinates' },
    'qpadm.build':   { videoId: 'qpadmRunning' },
    'qpadm.sources': { videoId: 'qpadmRunning', chapter: 'Sources and outgroups' },
    'qpadm.results': { videoId: 'qpadmReading' },
    pca:             { videoId: 'pca' },
    health:          { videoId: 'health' },
    familytree:      { videoId: 'familytree' },
    credits:         { videoId: 'credits' },
    sharing:         { videoId: 'savingSharing' },
}
